import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, isEqual } from 'lodash';

import { getPaymentCharge } from '../states/payments/builders';
import { getAllFxCharges } from '../states/rates/builders';
import { fxRatesPropTypes, fxRatesErrorPropTypes } from '../states/rates/propTypes';
import { getRates, getRatesError } from '../states/rates/selectors';

const mapState = (state) => ({
	fxRates: getRates(state),
	fxRatesError: getRatesError(state),
});

export default (WrappedComponent) => {
	const withFxCharge = class extends PureComponent {
		constructor(props) {
			super(props);
			const {
				payment: { payments },
				fxRates,
			} = props;
			this.state = {
				fxCharges: !isEmpty(fxRates) ? getAllFxCharges(fxRates) : getPaymentCharge(payments),
			};
		}
		componentWillReceiveProps(nextProps) {
			const { fxRates } = nextProps;
			if (!isEmpty(fxRates) && !isEqual(fxRates, this.props.fxRates)) {
				const fxCharges = getAllFxCharges(fxRates);
				this.setState({ fxCharges });
			}
		}
		render() {
			return <WrappedComponent {...this.props} fxCharges={this.state.fxCharges} />;
		}
	};

	withFxCharge.displayName = `withFxCharge(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

	withFxCharge.propTypes = {
		payment: PropTypes.shape({}).isRequired,
		fxRates: PropTypes.shape(fxRatesPropTypes),
		fxRatesError: PropTypes.shape(fxRatesErrorPropTypes),
	};

	return connect(mapState)(withFxCharge);
};
